import { makeStyles } from '@material-ui/core/styles'

export const RuDotsServiceCenterStyles = makeStyles((theme) => ({
  content: {
    padding: 0,
  },
  mainGrid: {
    height: '475px',
    display: 'flex',
  },
  scrollContent: {
    flex: 1,
    minHeight: '1px',
    overflowY: 'auto',
  },
  searchBar: {
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
  },
  imgContainer: {
    margin: 3,
    justifyContent: 'center',
  },
  img: {
    height: 35,
    width: 'auto',
    padding: 5,
  },
  modalTabs: {
    width: 335,
    height: 35,
    [theme.breakpoints.down(370)]: {
      width: 300,
    },
  },
  casesList: {
    width: '100%',
    overflow: 'auto',
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
  },
  bottomContainer: {
    width: '100%',
  },
  grid1: {
    borderColor: `${theme.palette.backgroundColor.ternary} !important`,
    borderTop: '1px solid',
    borderBottom: '1px solid',
    backgroundColor: theme.palette.base.blueGray,
  },
  tabLink: {
    position: 'relative',
    fontSize: '10px',
    color: 'white',
    bottom: 4,
  },
  footerText: {
    margin: 15,
    justifyContent: 'center',
    align: 'center',
    textAlign: 'center',
    lineHeight: 1.3,
  },
  announcementList: {
    width: '100%',
    overflow: 'auto',
    paddingTop: 10,
    paddingRight: 10,
    paddingLeft: 10,
  },
  circleIcon: {
    fontSize: 70,
    color: theme.palette.base.green,
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '4px 4px 0px 4px',
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
      backgroundColor: 'rgba(255, 255, 255, 0.21)',
      borderRadius: '4px',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.21)',
      borderRadius: '4px',
    },
  },
  tinyText: {
    fontSize: '10px',
    marginTop: '6.5px',
  },
}))

export const AnnouncementObjectStyles = makeStyles((theme) => ({
  gridItem: {
    width: '100%',
  },
  announcementCardBackground: {
    height: 'auto',
    padding: 10,
    paddingLeft: 15,
    paddingRight: 15,
    marginBottom: 15,
    width: '100%',
  },
  announcementDescription: {
    color: theme.palette.primary.headerText,
    width: '270px !important',
    textAlign: 'left',
  },
  iconButton: {
    position: 'relative',
    right: 5,
    padding: 0,
    paddingBottom: 5,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  expandOpen: {
    textAlign: 'left',
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandClosed: {
    justifyContent: 'left',
    textAlign: 'left',
    transform: 'rotate(180deg)',
  },
  descriptionText: {
    width: '270px !important',
    wordWrap: 'break-word',
    overflowWrap: 'break-word !important',
    display: 'inline-block',
  },
}))

export const MyCasesObjectStyles = makeStyles((theme) => ({
  gridItem: {
    width: '100%',
  },
  caseCardBackground: {
    height: 'auto',
    padding: 15,
    paddingBottom: 10,
    marginBottom: 15,
    width: '100%',
  },
  caseIDTextOpen: {
    width: '100%',
    textAlign: 'left',
    color: theme.palette.base.green,
  },
  caseIDTextClosed: {
    width: '100%',
    textAlign: 'left',
    color: theme.palette.base.red,
  },
}))
